<template>
	<div>
		<el-dialog v-model="dialogTableVisible" :show-close="false" title="查看图片" top="4vh" width="60%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<template #header>
				<el-row>
					<el-col :span="22" v-if="select_info">
						<el-row>
							<el-col :span="6">
								<el-col :span="24">
									<div class="goodDetails_name_title" style="">
										<span class="content">
											型号：{{img_title.model}}
										</span>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="goodDetails_name_title" style="">
										<span class="content">
											订货号：{{img_title.order_no}}
										</span>
									</div>
								</el-col>
							</el-col>
							<el-col :span="18" style="margin-top:20px">
								<div class="goodDetails_name_title" style="">
									<span class="content">
										数量：{{img_title.sur_num}}
									</span>
									<span class="content">
									</span>
									<span class="content" v-if="select_info" style="float: right;">
										<el-button type="danger" style="color:#fff;margin-right: 0.75rem;" @click="del">删除</el-button>
										<el-select style="width: 10rem" v-model="img_title.stock_type_txt">
											<el-option v-for="item in stocktype_list" :key="item.name" :label="item.name" :value="item.name" />
										</el-select>
										<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="updateStorckType">保存</el-button>
										<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="$emit('cutImg', this.img_title.index+1,1)">下一个产品</el-button>
									</span>
								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="22" v-else>
						<div class="goodDetails_name_title" style="">
							<span class="top">
								查看图片
							</span>
							<span class="content">
								型号：{{img_title.model}}
							</span>
							<span class="content">
								订货号：{{img_title.order_no}}
							</span>
							<span class="content">
								数量：{{img_title.sur_num}}
							</span>
						</div>
					</el-col>
					<el-col :span="2" style="text-align:right" class="Share_Close">
						<el-icon size="18px" @click="showShare_click" v-if="share_info">
							<Share />
						</el-icon>
						<el-icon size="18px" style="margin-left:10px" @click="dialogTableVisible=false">
							<Close />
						</el-icon>
					</el-col>
				</el-row>
			</template>
			<el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
				<el-tab-pane label="当前详情" name="img">
					<div class="goodDetails_name_img">
						<div class="goodDetails_name_img_div" style="height:62vh">
							<el-image :src="imgBigUrl" style="width: 100%;height: 100%" :preview-src-list="data" :zoom-rate="1.2" :initial-index="idx">
								<template #error>
									<div style="padding: 25% 45%;">
										暂无图片
									</div>
								</template>
							</el-image>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="疑似关联" name="list">
					<template #label>
						<span v-if="img_title.associate && img_title.associate.length">
							<el-badge :max="10000000" :value="img_title.associate.length" class="item">
								<span>疑似关联</span>
							</el-badge>
						</span>
						<span v-else>
							<span>疑似关联</span>
						</span>
					</template>
					<div class="goodDetails_name_img">
						<div class="goodDetails_name_img_div" style="height:62vh;overflow: auto;">
							<div style="">
								<el-descriptions title="" border>
									<el-descriptions-item label-class-name="my-label" class-name="my-content" label-width="11%" width="22%" label="品牌">{{img_title.brand_name}}</el-descriptions-item>
									<el-descriptions-item label-class-name="my-label" class-name="my-content" label-width="11%" width="22%" label="型号">{{img_title.model}}</el-descriptions-item>
									<el-descriptions-item label-class-name="my-label" class-name="my-content" label-width="11%" width="22%" label="订货号">{{img_title.order_no}}</el-descriptions-item>
								</el-descriptions>
							</div>
							<div style="margin-top:10px" v-for="(item,index) in (img_title.associate || [])">
								<el-descriptions title="" border>
									<el-descriptions-item label-width="11%" width="22%" label="品牌">{{item.brand_name}}</el-descriptions-item>
									<el-descriptions-item label-width="11%" width="22%" label="型号">{{item.model}}</el-descriptions-item>
									<el-descriptions-item label-width="11%" width="22%" label="订货号">{{item.order_no}}</el-descriptions-item>
									<el-descriptions-item class-name="remark_descriptions" label-width="11%" label="备注"><span v-html="item.remark.replace(/\n/g, '&lt;br&gt;')"></span></el-descriptions-item>
								</el-descriptions>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<div class="goodDetails_name_img">
				<el-row>
					<el-col :xs="7" :sm="5" :md="5" :lg="3" :xl="3" v-if="cutImg_info" style="margin-top: 2.5rem;">
						<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="$emit('cutImg', this.img_title.index-1,1)">上一个产品</el-button>
					</el-col>
					<el-col :xs="cutImg_info?10:24" :sm="cutImg_info?14:24" :md="cutImg_info?14:24" :lg="cutImg_info?18:24" :xl="cutImg_info?18:24">
						<div class="little_img">
							<span v-for="(item, index) in data" :key="index" @mouseenter="getUrl(item, index)">
								<img :src="item">
							</span>
						</div>
					</el-col>
					<el-col :xs="7" :sm="5" :md="5" :lg="3" :xl="3" v-if="cutImg_info && !select_info" style="margin-top: 2.5rem;">
						<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="$emit('cutImg', this.img_title.index+1,1)">下一个产品</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<el-dialog title="分享" v-model="showShare" width="40%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<el-form :model="shareForm">
				<el-form-item label="分享标题">
					<el-input placeholder="请输入分享标题" class="shareInp" v-model="shareForm.title"></el-input>
				</el-form-item>
				<!-- <el-form-item label="一口总价">
          <el-input placeholder="请输入一口总价" class="shareInp" v-model="shareForm.price"></el-input>
        </el-form-item> -->
				<el-form-item label="货主备注">
					<el-input placeholder="请输入您的联系方式，地址等" class="shareInp" type="textarea" :rows="3" v-model="shareForm.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" style="text-align:right">
				<el-button @click="cancleShare" class="cancle_btn">取 消</el-button>
				<el-button class="set_btn" @click="sureShare">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="分享" :close-on-click-modal="false" v-model="showqr" width="250">
			<div id="qrcode" style="text-align:center">
				<qrcode-vue :value="QRCodeVue_text" v-if="QRCodeVue_text" :size="200" level="H" />
			</div>
			<div class="qrText" style="text-align:center">分享至微信朋友圈</div>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
	name: '',
	components: {

	},
	data() {

		return {
			activeName: 'img',
			select_info: false,
			stocktype_list: [{
					id: 'A',
					name: '滞纳、在保、包附完好'
				},
				{
					id: 'B',
					name: '滞纳、在保、包附破损'
				},
				{
					id: 'C',
					name: '滞纳、过保、包附完好'
				},
				{
					id: 'D',
					name: '滞纳、过保、包附破损'
				},
				{
					id: 'E',
					name: '二手、在保、包附完好'
				},
				{
					id: 'F',
					name: '二手、在保、包附破损'
				},
				{
					id: 'G',
					name: '二手、过保、包附完好'
				},
				{
					id: 'H',
					name: '二手、过保、包附破损'
				}
			],
			QRCodeVue_text: '',
			shareForm: {},
			imgBigUrl: '',
			idx: 0,
			showqr: false,
			dialogTableVisible: false,
			showShare: false,
			share_info: true,
			cutImg_info: false,
			data: [],
			img_title: { model: '', order_no: '', sur_num: '', name: '', associate: [] },
		}
	},
	props: [],

	updated() {

	},

	watch: {

	},
	mounted() {

	},

	activated() {

	},
	created() {

	},

	methods: {
		handleClick() {

		},
		del() {
			ElMessageBox.confirm(
					'确认删除此数据，不可恢复！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {

					this.del_ajax()
				})
				.catch(() => {

				})

		},
		async del_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/deletestorage', { ids: [this.img_title.id] }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.$emit('cutImg', this.img_title.index, 1, true)
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async updateStorckType() {
			await this.$axios.post('/api/yunsys.storage/updateoneinfo', { stock_type_txt: this.img_title.stock_type_txt, id: this.img_title.id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					//需要修改外面列表的货物状态
					this.$emit('stockTypeTxtSave', this.img_title);
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})


				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})

		},
		getUrl(url, idx) {
			this.imgBigUrl = url
			this.idx = idx

		},
		cancleShare() {
			this.showShare = false
			this.shareForm = {}
		},
		async showShare_click() {
			await this.$axios.post('/api/yunsys.Website/getnameandtel', this.shareForm).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.shareForm.title = this.img_title.brand_name + ' ' + this.img_title.name + ' ' + this.img_title.model + ' 数量:' + this.img_title.num;
					this.shareForm.remark = res.data.linkman + res.data.mobile;
					this.showShare = true

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		// 确认分享
		async sureShare() {
			if (!this.shareForm.title) {
				return ElMessage({
					message: '请填写分享标题',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			this.shareForm.id = [this.img_title.id]
			await this.$axios.post('/api/yunsys.storage/share', this.shareForm).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.QRCodeVue_text = res.data.url

					this.$nextTick(function() {
						this.showqr = true
						this.showShare = false
						this.shareForm = {}

					})
					/*return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})*/

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})


		},
	}
}
</script>
<style lang="less" scoped>
:deep(.content .el-select) {
	width: 220px;
}

:deep(.el-button > span) {
	margin-right: 0px;
}

.goodDetails_name_title {
	line-height: 34px;
	overflow: hidden;
	white-space: nowrap;
}

.Share_Close {
	line-height: 34px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

:deep(.el-tabs__item.is-active) {
	// background-color: #f56c6c; /* 选中标签的背景颜色 */
	//border-color: #f56c6c; /* 选中标签的边框颜色 */
	color: #ff8a5c;
	/* 选中标签的文字颜色 */
}

:deep(.el-tabs__active-bar) {
	background-color: #ff8a5c;
	/* 选中标签下方的横线颜色 */
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}
:deep(.el-image-viewer__canvas .el-image-viewer__img){
	height: auto!important;
	width: auto !important;
}
:deep(.my-label) {
	background: #ff8a5c !important;
}

:deep(.my-content) {
	background: #ff8a5c !important;
}
:deep(.remark_descriptions){
	height: 80px;
}
</style>